<div
  class="text-center"
  style="color: #f00f0a; font-weight: bold; font-size: 14px"
>
  {{ errorMessage }}
</div>
